import { Spin } from 'antd'
import { PtoReferralStats } from 'Modules'
import { useEffect, useState } from 'react'

import { AppAdmin } from 'api/app-admin'
import { logError } from 'utils/logger'

interface PtoReferralOverviewCardsProps {
  /** Stats fetcher. Defaults to the normal-users stats endpoint. */
  fetchStats?: typeof AppAdmin.getPtoReferralStats
}

export const PtoReferralOverviewCards = ({ fetchStats }: PtoReferralOverviewCardsProps = {}) => {
  const [stats, setStats] = useState<PtoReferralStats>({
    totalReferrers: 0,
    totalReferredUsers: 0,
    totalPayout: { amount: 0 },
    allTimePayout: { amount: 0 },
  })
  const [loading, setLoading] = useState(false)

  const loadStats = async () => {
    try {
      setLoading(true)
      const { data } = await (fetchStats ?? AppAdmin.getPtoReferralStats)()

      if (data?.data) {
        const d = data.data
        // Partner stats use `totalPartners`; normal stats use `totalReferrers`.
        setStats({
          totalReferrers: d.totalReferrers ?? d.totalPartners ?? 0,
          totalReferredUsers: d.totalReferredUsers ?? 0,
          totalPayout: d.totalPayout ?? { amount: 0 },
          allTimePayout: d.allTimePayout ?? { amount: 0 },
        })
      }
    } catch (error) {
      logError('Error fetching PTO referral stats:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadStats()
  }, [])

  const cards = [
    {
      title: 'Total Referrers',
      value: stats.totalReferrers,
    },
    {
      title: 'Total Referred Users',
      value: stats.totalReferredUsers,
    },
    {
      title: 'Total Payout',
      value: stats.totalPayout?.amount ?? 0,
      suffix: ' MEY',
    },
    {
      title: 'All-Time Payout',
      value: stats.allTimePayout?.amount ?? 0,
      suffix: ' MEY',
    },
  ]

  return (
    <div className="dashboard-container">
      <div className="wrap-dashboard">
        <div className="wrap-box">
          <div className="wrap-columns">
            <div className="columns" style={{ display: 'flex', gap: '20px' }}>
              {cards.map((card) => (
                <div key={card.title} className="colum" style={{ flex: 1 }}>
                  <div className="guide-box">
                    <div className="box-content">
                      <div className="left-s">
                        <div className="txt">{card.title}</div>
                        <div className="number">
                          {loading ? (
                            <Spin />
                          ) : (
                            <>
                              {new Intl.NumberFormat('en-US').format(card.value)}
                              {card.suffix}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
